import React, { useState } from 'react';
import { EngravingInputOptionGrid } from './EngravingInputOptionGrid';
import { useTranslation } from 'react-i18next';
import { useToggle } from '@gift/ui/hooks/useToggle';
import { Mobile } from '@gift/ui/components/breakpoints/Mobile';
import { ConfirmModal } from '@gift/ui/components/modal/ConfirmModal';
import { AccordionField } from '@gift/ui/components/accordion/partials/AccordionField';
import { AccordionPreviewImage } from '@gift/ui/components/accordion/partials/AccordionPreviewImage';

export const EngravingInputControlModal = ({
    name, commit,
    collectionId, variableIds,
    selectedAssetUrl, shouldDisplayIcon
}: Props) => {

    const [isOpen, toggleOpen] = useToggle();
    const [localValue, setLocalValue] = useState(selectedAssetUrl);
    const showIcon = shouldDisplayIcon && selectedAssetUrl;
    const { t } = useTranslation();

    const cancel = () => {
        setLocalValue(selectedAssetUrl);
        toggleOpen();
    };

    const onConfirm = () => {
        commit(localValue);
        toggleOpen();
    };

    return (
        <Mobile>
            <AccordionField onClick={toggleOpen} active={isOpen}>
                {showIcon && <AccordionPreviewImage src={selectedAssetUrl} />}
                {t(name)}
            </AccordionField>
            {isOpen && (
                /* i18next-extract-disable-next-line */
                <ConfirmModal title={t(name)} active={true}
                    onReject={cancel} onConfirm={onConfirm}>
                    <EngravingInputOptionGrid
                        variableIds={variableIds}
                        collectionId={collectionId}
                        selectedAssetUrl={localValue}
                        onClick={setLocalValue} />
                </ConfirmModal>
            )}
        </Mobile>
    );
};

type Props = {
    name: string,
    variableIds: string[],
    collectionId: string,
    selectedAssetUrl: string,
    shouldDisplayIcon: boolean,
    commit: (svgUrl: string) => void
};
